import React from 'react'
import { Flex, Box, Text, Image } from 'rebass'
import { useNewTranslation } from 'hooks/index'

import { theme } from 'theme'
import ButtonText from 'components/Shared/Button/OldButton/ButtonText'
import { buildCloudinaryUrl } from 'services/cloudinary'
import { parseBackendDate } from 'services/dates'
import { useDispatch, useSelector } from 'react-redux'
import { SubmissionProgressProps, selectSelectedCampaignSummary } from 'state/review'
import { selectProfileDetails } from 'state'
import { deleteDiscussSubmission, selectLatestVoteAndDiscussion } from 'state/submissions'
import { spacing } from 'particles/styles'
import Avatar from 'particles/Avatar'

interface DiscussionListProps {
    submissionProgress: SubmissionProgressProps
    setSelectedDiscussionContent: any
    selectedDiscussionUuid: string
}

const DiscussionList: React.FC<DiscussionListProps> = ({
    submissionProgress,
    setSelectedDiscussionContent,
    selectedDiscussionUuid,
}) => {
    const dispatch = useDispatch()
    const [newT] = useNewTranslation()
    const selectedCampaignSummary = useSelector(selectSelectedCampaignSummary)
    const selectedCampaignUuid = selectedCampaignSummary?.uuid
    const profile = useSelector(selectProfileDetails)
    const { latest_discussion: latestDiscussion, votes } = useSelector(
        selectLatestVoteAndDiscussion(submissionProgress.uuid),
    )

    const handleDeleteDiscuss = (discussionUuid: string) => {
        if (selectedCampaignUuid) {
            dispatch(
                deleteDiscussSubmission({
                    campaignUuid: selectedCampaignUuid,
                    submissionUuid: submissionProgress.uuid,
                    discussionUuid,
                }),
            )
        }
    }
    return (
        <Box minHeight={latestDiscussion.length ? '400px' : '300px'}>
            {latestDiscussion.map((discussion, index) => {
                const isOwner = profile.uuid == discussion.cprofile.uuid
                const isApproved = votes.approve.findIndex(vote => vote.uuid == discussion.cprofile.uuid) >= 0
                const isEditRequired = votes.request_edits.findIndex(vote => vote.uuid == discussion.cprofile.uuid) >= 0
                const isReject = votes.reject.findIndex(vote => vote.uuid == discussion.cprofile.uuid) >= 0
                const indicator = isApproved ? 'approve' : isEditRequired ? 'edit' : isReject ? 'reject' : undefined
                const isEditing = discussion.uuid === selectedDiscussionUuid

                return (
                    <div key={index}>
                        <Flex
                            alignItems="left"
                            key={discussion.cprofile.uuid}
                            my={theme.spacing.xxxs}
                            sx={{ gap: spacing[400] }}
                        >
                            <Avatar profile={discussion.cprofile} form={indicator} />
                            <Box flex="1" sx={{ borderBottom: '1px solid #E5E5E5' }}>
                                <Flex>
                                    <Box flex={1 / 2}>
                                        <Text textAlign="left" fontSize="2">
                                            {discussion.cprofile.name}
                                        </Text>
                                    </Box>
                                    <Box flex={1 / 2}>
                                        <Text textAlign="right" color={theme.colors.boulder} fontSize="0.8em">
                                            {selectedCampaignSummary
                                                ? parseBackendDate(
                                                      discussion.updated_at,
                                                      selectedCampaignSummary.country,
                                                      {
                                                          showTime: true,
                                                      },
                                                  )
                                                : ''}
                                        </Text>
                                    </Box>
                                </Flex>
                            </Box>
                        </Flex>
                        <Box ml="3rem" sx={{ display: 'flex', alignItems: 'center' }}>
                            {discussion.files.map((value: any, index: number) => (
                                <Box key={index} width="25%" m="4px">
                                    {value.resource_type === 'image' && <Image src={buildCloudinaryUrl(value)} />}
                                    {value.resource_type === 'video' && (
                                        <video width="100%">
                                            <source src={buildCloudinaryUrl(value)} />
                                        </video>
                                    )}
                                </Box>
                            ))}
                        </Box>
                        <Flex>
                            <Box ml="3.5rem" sx={{ overflow: 'hidden' }}>
                                <Text sx={{ display: 'inline', whiteSpace: 'pre-line' }}>{discussion.comment}</Text>
                                {discussion.is_edited && (
                                    <Text sx={{ display: 'inline' }} color="#878787" ml="1rem">
                                        ({newT('submission.review.editedIndicator')})
                                    </Text>
                                )}
                            </Box>
                        </Flex>
                        {isOwner && !isEditing && (
                            <Flex ml="2.5rem">
                                <Box width={1 / 3}>
                                    <ButtonText
                                        fontSize="0.8em"
                                        color={theme.colors.astronaut}
                                        onClick={() => setSelectedDiscussionContent(discussion)}
                                    >
                                        {newT('button.edit')}
                                    </ButtonText>
                                </Box>
                                <Box width={1 / 3}>
                                    <ButtonText
                                        fontSize="0.8em"
                                        color={theme.colors.astronaut}
                                        onClick={() => handleDeleteDiscuss(discussion.uuid)}
                                    >
                                        {newT('button.delete')}
                                    </ButtonText>
                                </Box>
                            </Flex>
                        )}
                        <Box mb={theme.spacing.s}></Box>
                    </div>
                )
            })}
        </Box>
    )
}
export default DiscussionList
